import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, vModelRadio as _vModelRadio, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29ffa082"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_waiting_approve",
  ref: "waitingApproveRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_waiting_approve_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1))
const _hoisted_8 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "modal-body px-17 py-9" }
const _hoisted_11 = { class: "timeline" }
const _hoisted_12 = {
  key: 0,
  class: "timeline-item"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1))
const _hoisted_14 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_15 = { class: "symbol-label bg-light" }
const _hoisted_16 = { class: "svg-icon svg-icon-1" }
const _hoisted_17 = { class: "timeline-content mb-10 mt-n1 px-3" }
const _hoisted_18 = { class: "fs-5 fw-bold mb-1" }
const _hoisted_19 = { class: "d-flex align-items-center fs-6" }
const _hoisted_20 = { class: "fs-7 text-muted" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "svg-icon svg-icon-2x mx-1" }
const _hoisted_23 = {
  key: 0,
  class: "d-inline-flex position-relative"
}
const _hoisted_24 = {
  key: 0,
  class: "svg-icon svg-icon-3 position-absolute top-0 end-0 mt-7 me-3 cursor-pointer",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_inspection_waiting_approve_image"
}
const _hoisted_25 = { class: "overflow-auto py-5" }
const _hoisted_26 = { class: "d-flex flex-column gap-4" }
const _hoisted_27 = { class: "d-flex align-items-center gap-4" }
const _hoisted_28 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_29 = { class: "upload-photos py-5" }
const _hoisted_30 = { class: "svg-icon svg-icon-5tx svg-icon-primary" }
const _hoisted_31 = { class: "el-upload__text" }
const _hoisted_32 = { class: "thumbnail-item" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "el-upload-list__item-actions" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, null, -1))
const _hoisted_40 = {
  key: 1,
  class: "timeline-item"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1))
const _hoisted_42 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_43 = { class: "symbol-label bg-light" }
const _hoisted_44 = { class: "svg-icon svg-icon-1" }
const _hoisted_45 = { class: "timeline-content mb-10 mt-n1 px-3" }
const _hoisted_46 = { class: "fs-5 fw-bold mb-1" }
const _hoisted_47 = { class: "d-flex align-items-center fs-6" }
const _hoisted_48 = { class: "fs-7 text-muted" }
const _hoisted_49 = { class: "d-flex align-items-center" }
const _hoisted_50 = { class: "svg-icon svg-icon-2x mx-1" }
const _hoisted_51 = { class: "py-5" }
const _hoisted_52 = { class: "fs-7 text-gray-400" }
const _hoisted_53 = { class: "timeline-item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1))
const _hoisted_55 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_56 = { class: "symbol-label bg-light" }
const _hoisted_57 = { class: "svg-icon svg-icon-1" }
const _hoisted_58 = { class: "timeline-content mb-10 mt-n1 px-3" }
const _hoisted_59 = { class: "fs-5 fw-bold mb-1" }
const _hoisted_60 = { class: "d-flex align-items-center fs-6" }
const _hoisted_61 = {
  key: 0,
  class: "fs-7 text-muted"
}
const _hoisted_62 = {
  key: 1,
  class: "fs-7 text-muted"
}
const _hoisted_63 = { class: "d-flex align-items-center" }
const _hoisted_64 = { class: "svg-icon svg-icon-2x mx-1" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = {
  key: 0,
  class: "py-5"
}
const _hoisted_68 = { class: "w-100 d-flex flex-column gap-4 lh-sm" }
const _hoisted_69 = { class: "d-flex align-items-center cursor-pointer" }
const _hoisted_70 = { class: "symbol symbol-50px overflow-hidden" }
const _hoisted_71 = { class: "flex-fill mx-2" }
const _hoisted_72 = { class: "fw-bold fs-5" }
const _hoisted_73 = { class: "fs-6 text-gray-400" }
const _hoisted_74 = { class: "d-flex align-items-center" }
const _hoisted_75 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_76 = ["value"]
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-md-12 form-group" }
const _hoisted_79 = { class: "form-label fw-bold" }
const _hoisted_80 = {
  key: 1,
  class: "py-5"
}
const _hoisted_81 = {
  key: 0,
  class: "fs-7 text-gray-400"
}
const _hoisted_82 = {
  key: 1,
  class: "fs-7 text-gray-400"
}
const _hoisted_83 = {
  key: 2,
  class: "overflow-auto py-5"
}
const _hoisted_84 = { class: "timeline-icon symbol symbol-circle symbol-50px me-4" }
const _hoisted_85 = { class: "svg-icon svg-icon-2tx svg-icon-light m-0" }
const _hoisted_86 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_87 = { class: "fw-semibold text-start" }
const _hoisted_88 = { class: "text-gray-800 fw-bold" }
const _hoisted_89 = { class: "fs-6 text-gray-400 lh-sm" }
const _hoisted_90 = {
  key: 0,
  class: "modal-footer align-items-center justify-content-end"
}
const _hoisted_91 = ["disabled"]
const _hoisted_92 = { class: "indicator-label" }
const _hoisted_93 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_94 = { class: "indicator-progress" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_waiting_approve_image_modal = _resolveComponent("waiting-approve-image-modal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.inspection")) + " ", 1),
                    _createElementVNode("span", null, "/ #" + _toDisplayString(_ctx.itemData.identifier_code), 1),
                    (_ctx.itemData.order_number)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _createElementVNode("span", null, " / #" + _toDisplayString(_ctx.itemData.order_number), 1),
                          _createElementVNode("span", null, "#" + _toDisplayString(_ctx.itemData.position), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ])
                ])
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.itemData.inspection_date)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, [
                              _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspect.svg" })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.itemData.__show.reason), 1),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("inspection.firstTimeInspectedDate", [
                            _ctx.customFormatDateTime(_ctx.itemData.inspection_date),
                          ])), 1),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com006.svg" })
                                ]),
                                _createElementVNode("div", null, _toDisplayString(_ctx.itemData.__show.inspection_manager), 1)
                              ])
                            ])
                          ]),
                          (_ctx.formData.images.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                (
                        _ctx.itemData.inspection_result ===
                          _ctx.InspectionResult.Passed && _ctx.formData.images.length > 0
                      )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["d-flex align-items-center border border-dashed border-gray-300 rounded px-3 py-7", {
                              'pt-16':
                                _ctx.itemData.inspection_result ===
                                _ctx.InspectionResult.Passed,
                            }])
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.images, (row, rowIndex) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "d-flex align-items-center",
                                            key: rowIndex
                                          }, [
                                            _createVNode(_component_el_image, {
                                              class: "w-200px h-100px cursor-pointer",
                                              fit: "contain",
                                              src: 
                                  row.url + '?x-oss-process=image/resize,l_200'
                                ,
                                              onClick: ($event: any) => (_ctx.previewImages(rowIndex))
                                            }, null, 8, ["src", "onClick"])
                                          ]))
                                        }), 128))
                                      ], 2)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (
                      _ctx.itemData.inspection_result === _ctx.InspectionResult.Passed &&
                      _ctx.formData.images.length === 0
                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                    ref: "uploadRef",
                                    class: _normalizeClass(["multiple-drag-upload bg-light-primary rounded border-primary border border-dashed", { hasfile: _ctx.formData.images.length > 0 }]),
                                    drag: "",
                                    multiple: "",
                                    "file-list": _ctx.formData.images,
                                    "auto-upload": false,
                                    "show-file-list": true,
                                    accept: ".jpg,.jpeg,.png",
                                    headers: _ctx.uploadHeaders,
                                    "on-change": _ctx.onUploadChange,
                                    "on-error": _ctx.onUploadError
                                  }, {
                                    file: _withCtx(({ file }) => [
                                      _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("img", {
                                          class: "el-upload-list__item-thumbnail",
                                          src: file.url,
                                          alt: ""
                                        }, null, 8, _hoisted_33),
                                        _createElementVNode("span", _hoisted_34, [
                                          _createElementVNode("span", {
                                            class: "el-upload-list__item-preview",
                                            onClick: ($event: any) => (_ctx.handleFilePreview(file))
                                          }, [
                                            _createElementVNode("span", _hoisted_36, [
                                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen004.svg" })
                                            ])
                                          ], 8, _hoisted_35),
                                          (_ctx.itemData.is_stock === 0)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "el-upload-list__item-delete",
                                                onClick: ($event: any) => (_ctx.handleRemove(file))
                                              }, [
                                                _createElementVNode("span", _hoisted_38, [
                                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr015.svg" })
                                                ])
                                              ], 8, _hoisted_37))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]),
                                    tip: _withCtx(() => [
                                      _hoisted_39
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_30, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil022.svg" })
                                      ]),
                                      _createElementVNode("div", _hoisted_31, [
                                        _createTextVNode(_toDisplayString(_ctx.t("common.uploadDrop")) + " ", 1),
                                        _createElementVNode("em", null, _toDisplayString(_ctx.t("common.uploadClick")), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["class", "file-list", "headers", "on-change", "on-error"])), [
                                    [_directive_loading, _ctx.uploadLoading]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.itemData.second_inspection_date)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _hoisted_41,
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("span", _hoisted_44, [
                              _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspect.svg" })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.itemData.__show.second_inspection_result), 1),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.t("inspection.secondTimeInspectedDate", [
                            _ctx.customFormatDateTime(
                              _ctx.itemData.second_inspection_date
                            ),
                          ])), 1),
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("span", _hoisted_50, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com006.svg" })
                                ]),
                                _createElementVNode("div", null, _toDisplayString(_ctx.itemData.__show.second_inspection_manager), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.itemData.second_inspection_notes), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("span", _hoisted_57, [
                          _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspect.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.t("inspection.inspectionResult")), 1),
                        _createElementVNode("div", _hoisted_60, [
                          (!_ctx.formData.submit)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.t("inspection.plsSelectOption")), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.t("inspection.reviewed", [
                            _ctx.itemData.review_date
                              ? _ctx.customFormatDateTime(_ctx.itemData.review_date)
                              : _ctx.customFormatDateTime(new Date()),
                          ])), 1)),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("span", _hoisted_64, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com006.svg" })
                            ]),
                            (_ctx.itemData.review_date)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.itemData.__show.reviewer), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.userInfo?.username), 1))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        (!_ctx.formData.submit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                              _withDirectives(_createVNode(_component_el_form_item, { prop: "images" }, null, 512), [
                                [_vShow, 0]
                              ]),
                              _withDirectives(_createVNode(_component_el_form_item, { prop: "uploadList" }, null, 512), [
                                [_vShow, 0]
                              ]),
                              _withDirectives(_createVNode(_component_el_form_item, { prop: "submit" }, null, 512), [
                                [_vShow, 0]
                              ]),
                              _createVNode(_component_el_form_item, { prop: "radio" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_68, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.result, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "w-100",
                                        key: index
                                      }, [
                                        _createElementVNode("label", _hoisted_69, [
                                          _createElementVNode("div", _hoisted_70, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["symbol-label", 
                                    _ctx.getInspectionResultBgStyleMap(
                                      Number(item.value)
                                    )
                                  ])
                                            }, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["svg-icon svg-icon-1", 
                                      _ctx.getInspectionResultSvgStyleMap(
                                        Number(item.value)
                                      )
                                    ])
                                              }, [
                                                _createVNode(_component_inline_svg_icon, {
                                                  src: 
                                        _ctx.getInspectionResultSvgMap(
                                          Number(item.value)
                                        )
                                      
                                                }, null, 8, ["src"])
                                              ], 2)
                                            ], 2)
                                          ]),
                                          _createElementVNode("div", _hoisted_71, [
                                            _createElementVNode("div", _hoisted_72, _toDisplayString(item.label), 1),
                                            _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.getInspectionResultDescriptionMap(
                                      Number(item.value),
                                      _ctx.t
                                    )), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("span", _hoisted_75, [
                                              _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "radio",
                                                name: "result",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.radio) = $event)),
                                                value: item.value
                                              }, null, 8, _hoisted_76), [
                                                [_vModelRadio, _ctx.formData.radio]
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_77, [
                                _createElementVNode("div", _hoisted_78, [
                                  _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.t("inspection.inspectionNote")), 1),
                                  _createVNode(_component_el_form_item, { prop: "notes" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.formData.notes,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.notes) = $event)),
                                        type: "textarea",
                                        placeholder: _ctx.t('common.plsEnter'),
                                        clearable: ""
                                      }, null, 8, ["modelValue", "placeholder"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.formData.submit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                              (_ctx.itemData.inspection_result === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.formData.notes), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(_ctx.itemData.inspection_notes), 1))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.formData.submit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.resultArr, (item, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                  (_ctx.formData.radio === item.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["flex-fill notice d-flex rounded border border-dashed p-6", {
                            'bg-light-success':
                              item.value === String(_ctx.InspectionResult.Passed),
                            'border-success':
                              item.value === String(_ctx.InspectionResult.Passed),
                            'bg-light-warning':
                              item.value ===
                                String(_ctx.InspectionResult.InternalLoss) ||
                              item.value ===
                                String(_ctx.InspectionResult.DefectedArticle),
                            'border-warning':
                              item.value ===
                                String(_ctx.InspectionResult.InternalLoss) ||
                              item.value ===
                                String(_ctx.InspectionResult.DefectedArticle),
                            'bg-light-info':
                              item.value ===
                              String(_ctx.InspectionResult.RetourToMerchant),
                            'border-info':
                              item.value ===
                              String(_ctx.InspectionResult.RetourToMerchant),
                            'bg-light':
                              item.value ===
                              String(_ctx.InspectionResult.CreatedBackOrder),
                          }])
                                      }, [
                                        _createElementVNode("div", _hoisted_84, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["symbol-label", {
                                'bg-success':
                                  item.value ===
                                  String(_ctx.InspectionResult.Passed),
                                'bg-warning':
                                  item.value ===
                                    String(_ctx.InspectionResult.InternalLoss) ||
                                  item.value ===
                                    String(_ctx.InspectionResult.DefectedArticle),
                                'bg-info':
                                  item.value ===
                                  String(_ctx.InspectionResult.RetourToMerchant),
                                'bg-dark':
                                  item.value ===
                                  String(_ctx.InspectionResult.CreatedBackOrder),
                              }])
                                          }, [
                                            _createElementVNode("span", _hoisted_85, [
                                              _createVNode(_component_inline_svg_icon, {
                                                src: 
                                    _ctx.getInspectionResultSvgMap(
                                      Number(item.value)
                                    )
                                  
                                              }, null, 8, ["src"])
                                            ])
                                          ], 2)
                                        ]),
                                        _createElementVNode("div", _hoisted_86, [
                                          _createElementVNode("div", _hoisted_87, [
                                            _createElementVNode("h4", _hoisted_88, _toDisplayString(item.label), 1),
                                            _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.getInspectionResultDescriptionMap(
                                    Number(item.value),
                                    _ctx.t
                                  )), 1)
                                          ])
                                        ])
                                      ], 2))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              (!_ctx.formData.submit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                    _createElementVNode("button", {
                      type: "button",
                      ref: _ctx.submitButton,
                      disabled: _ctx.loading,
                      class: "btn btn-lg btn-primary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_92, [
                        _createElementVNode("span", _hoisted_93, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_94, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_95
                      ])
                    ], 8, _hoisted_91)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ], 512),
    _createVNode(_component_waiting_approve_image_modal, {
      itemData: _ctx.itemData,
      files: _ctx.formData.images,
      infoData: _ctx.formData,
      filesId: _ctx.formData.file_upload_record_id,
      onUpdateList: _ctx.getFormInfo
    }, null, 8, ["itemData", "files", "infoData", "filesId", "onUpdateList"])
  ], 64))
}